import { useEffect } from "react";
import PixelService from "./pixel-service";
import { useLocation } from "react-router-dom";

export const usePixelServiceOnLoad = () => {
  const location = useLocation();
  useEffect(() => {
    PixelService.pixelPageView(location.pathname);
  }, [location.pathname]);
};
